<template>
    <div class="auto-list form-control">
        <input type="hidden" name="website_id" :value="entity.id" />
        <input :id="id" name="website_name" type="text" class="form-control popup-input" autocomplete="off"
               v-model="query" @focus="blankEntry = false" @blur="checkBlankEntry()" :placeholder="placeholder" />
        <span class="popup-alert error" v-if="hasError">{{ hasError }}</span>
    </div>
</template>
<script>
    import Base from './base.js';
    export default {
        mixins: [ Base ],
        props: {
            placeholder: { default: '' },
        },
        data () {
            return {
                mydata: {},
                index_name: 'websites',
            }
        },
        created(){
            this.$eventHub.$on('blurWebsite', this.blurSite);
        },
        methods: {
            blurSite() {
                this.query = '';
            },
            error(data){
                if(typeof data.errorName !== 'undefined') {
                    if(data.errorName === this.errorName) {
                        if(typeof data.errors['website.id'] !== 'undefined'){
                            this.hasError = data.errors['website.id'][0];
                        }
                    }
                }
            },
            entityName(item) {
                let url = item.dev_domain;
                if (item.is_live === 1) {
                    url = item.domain;
                }
                return item.site_name + " - " + url;
            }
        }
    }
</script>